module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "fron-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_fron1"
    }
  }, [_vm._v("HIGH PRAISE FOR "), _c('em', [_c('strong', [_vm._v("BENEATH THE SKIN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "adcard"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/BENEATHTHESKIN_adcard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Nicci French")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "copy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/BENEATHTHESKIN_copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "part-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_part1"
    }
  }, [_vm._v("PART ONE: Zoe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap1"
    }
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap2"
    }
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap3"
    }
  }, [_vm._v("THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap4"
    }
  }, [_vm._v("FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap5"
    }
  }, [_vm._v("FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap6"
    }
  }, [_vm._v("SIX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap7"
    }
  }, [_vm._v("SEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap8"
    }
  }, [_vm._v("EIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap9"
    }
  }, [_vm._v("NINE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap10"
    }
  }, [_vm._v("TEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap11"
    }
  }, [_vm._v("ELEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap12"
    }
  }, [_vm._v("TWELVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap13"
    }
  }, [_vm._v("THIRTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "part-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_part2"
    }
  }, [_vm._v("PART TWO: Jennifer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap14"
    }
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap15"
    }
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap16"
    }
  }, [_vm._v("THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap17"
    }
  }, [_vm._v("FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap18"
    }
  }, [_vm._v("FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap19"
    }
  }, [_vm._v("SIX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap20"
    }
  }, [_vm._v("SEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap21"
    }
  }, [_vm._v("EIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap22"
    }
  }, [_vm._v("NINE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap23"
    }
  }, [_vm._v("TEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap24"
    }
  }, [_vm._v("ELEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap25"
    }
  }, [_vm._v("TWELVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap26"
    }
  }, [_vm._v("THIRTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap27"
    }
  }, [_vm._v("FOURTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "part-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_part3"
    }
  }, [_vm._v("PART THREE: Nadia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap28"
    }
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap29"
    }
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap30"
    }
  }, [_vm._v("THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap31"
    }
  }, [_vm._v("FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap32"
    }
  }, [_vm._v("FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap33"
    }
  }, [_vm._v("SIX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap34"
    }
  }, [_vm._v("SEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap35"
    }
  }, [_vm._v("EIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap36"
    }
  }, [_vm._v("NINE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap37"
    }
  }, [_vm._v("TEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap38"
    }
  }, [_vm._v("ELEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap39"
    }
  }, [_vm._v("TWELVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap40"
    }
  }, [_vm._v("THIRTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap41"
    }
  }, [_vm._v("FOURTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap42"
    }
  }, [_vm._v("FIFTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap43"
    }
  }, [_vm._v("SIXTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap44"
    }
  }, [_vm._v("SEVENTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-45"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap45"
    }
  }, [_vm._v("EIGHTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-46"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap46"
    }
  }, [_vm._v("NINETEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-47"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap47"
    }
  }, [_vm._v("TWENTY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-48"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap48"
    }
  }, [_vm._v("TWENTY-ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-49"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap49"
    }
  }, [_vm._v("TWENTY-TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap50"
    }
  }, [_vm._v("TWENTY-THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-51"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_chap51"
    }
  }, [_vm._v("TWENTY-FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "teas-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_teas1"
    }
  }, [_vm._v("eBook Special Feature:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "teas-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_teas2"
    }
  }, [_vm._v("A Preview of \"KILLING ME SOFTLY\"")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "teas-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_teas3"
    }
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "teas-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_teas4"
    }
  }, [_vm._v("A Preview of \"THE RED ROOM\"")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "teas-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_teas5"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "teas-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/BENEATHTHESKIN_teas6"
    }
  }, [_vm._v("A Preview of \"LAND OF THE LIVING\"")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f1b2b52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BENEATHTHESKIN_toc.vue
// module id = 69
// module chunks = 0